import { StoreDeliveryFeeType } from 'types/storeDeliveryFee'

export const CONFIRM_STORE_DELIVERY_FEES = 'CONFIRM_STORE_DELIVERY_FEES'
export const confirmStoreDeliveryFeesAction = (storeDeliveryFees: StoreDeliveryFeeType[]) => {
  return {
    type: 'CONFIRM_STORE_DELIVERY_FEES',
    payload: storeDeliveryFees,
  }
}

export const FETCH_STORE_DELIVERY_FEES = 'FETCH_STORE_DELIVERY_FEES'
export const fetchStoreDeliveryFeesAction = (storeDeliveryFees: StoreDeliveryFeeType[]) => {
  return {
    type: 'FETCH_STORE_DELIVERY_FEES',
    payload: storeDeliveryFees,
  }
}

export const INIT_STORE_DELIVERY_FEES = 'INIT_STORE_DELIVERY_FEES'
export const initStoreDeliveryFeesAction = () => {
  return {
    type: 'INIT_STORE_DELIVERY_FEES',
    payload: null,
  }
}
